/* global Global */
import Patterns from '../patterns.js';

export default [
  ...Global.years.map((year, idx) => {
    return {
      name: `wbscIds.${idx}`,
      label: {
        cs: `WBSC ID (${year})`,
        en: `WBSC ID (${year})`,
      },
      type: 'integer',
      min: 0,
      max: 999999,
    };
  }),
  {
    name: 'shortcut',
    label: {
      cs: 'Zkratka',
      en: 'Shortcut',
    },
    type: 'string',
    pattern: Patterns.ONLY_LOWER_CASE_WITH_NUMBERS,
    patternErrorMessage: Patterns.ONLY_LOWER_CASE_WITH_NUMBERS_MESSAGE,
    minLength: 3,
    maxLength: 4,
    required: true,
  },
  {
    name: 'name.cs',
    label: {
      cs: 'Název [CS]',
      en: 'Name [CS]',
    },
    type: 'string',
    pattern: Patterns.ACCENTS_WITH_NUMBERS,
    patternErrorMessage: Patterns.ACCENTS_WITH_NUMBERS_MESSAGE,
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'name.en',
    label: {
      cs: 'Název [EN]',
      en: 'Name [EN]',
    },
    type: 'string',
    pattern: Patterns.ACCENTS_WITH_NUMBERS,
    patternErrorMessage: Patterns.ACCENTS_WITH_NUMBERS_MESSAGE,
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'city',
    label: {
      cs: 'Město',
      en: 'City',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 32,
  },
  {
    name: 'address',
    label: {
      cs: 'Adresa',
      en: 'Address',
    },
    type: 'string',
    pattern: Patterns.ALPHANUMERIC,
    patternErrorMessage: Patterns.ALPHANUMERIC_MESSAGE,
    minLength: 2,
    maxLength: 32,
  },
  {
    name: 'longitude',
    label: {
      cs: 'Zeměpisná délka',
      en: 'Longitude',
    },
    type: 'number',
    min: -180,
    max: 180,
    required: true,
  },
  {
    name: 'latitude',
    label: {
      cs: 'Zeměpisná šířka',
      en: 'Latitude',
    },
    type: 'number',
    min: -90,
    max: 90,
    required: true,
  },
  {
    name: 'tour.cs',
    label: {
      cs: 'Prohlídka [CS]',
      en: 'Tour [CS]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 32,
  },
  {
    name: 'tour.en',
    label: {
      cs: 'Prohlídka [EN]',
      en: 'Tour [EN]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 32,
  },
  {
    name: 'content.cs',
    label: {
      cs: 'Obsah [CS]',
      en: 'Content [CS]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 5096,
  },
  {
    name: 'content.en',
    label: {
      cs: 'Obsah [EN]',
      en: 'Content [EN]',
    },
    type: 'string',
    minLength: 2,
    maxLength: 5096,
  },
  {
    name: 'slot',
    label: {
      cs: 'Slot',
      en: 'Slot',
    },
    type: 'integer',
    min: -1,
    max: 99,
  },
];
